// tippi/src/contexts/PricingSettingsContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { FALLBACK_BASE_RATE } from '../utils/priceCalculator';

const PricingSettingsContext = createContext({ baseRate: FALLBACK_BASE_RATE, loading: true, error: null });

export function PricingSettingsProvider({ children }) {
  const [baseRate, setBaseRate] = useState(FALLBACK_BASE_RATE);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    getDoc(doc(db, 'settings', 'pricing'))
      .then(snap => {
        const data = snap.data();
        if (snap.exists() && data.baseRatePerKm != null) {
          setBaseRate(data.baseRatePerKm);
        }
      })
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PricingSettingsContext.Provider value={{ baseRate, loading, error }}>
      {children}
    </PricingSettingsContext.Provider>
  );
}

export function usePricingSettings() {
  return useContext(PricingSettingsContext);
}
